import { render, staticRenderFns } from "./Personalcenter.vue?vue&type=template&id=afbbd04e&scoped=true&"
import script from "./Personalcenter.vue?vue&type=script&lang=js&"
export * from "./Personalcenter.vue?vue&type=script&lang=js&"
import style0 from "./Personalcenter.vue?vue&type=style&index=0&id=afbbd04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbbd04e",
  null
  
)

export default component.exports